<template>
  <div class="pa-10">
    <!-- <DSSCriterionDataTable v-if="$store.state.user.usertype.id == 2" /> -->
    <ProgramDSSCriterionDataTable />
  </div>
</template>

<script>
// import DSSCriterionDataTable from "../../components/Utils/DSSCriterionDataTable.vue";
import ProgramDSSCriterionDataTable from "@/components/Utils/ProgramDSSCriterionDataTable.vue";
export default {
  components: {
    // DSSCriterionDataTable,
    ProgramDSSCriterionDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
